import { render, staticRenderFns } from "./no-pc.vue?vue&type=template&id=590e66cc&scoped=true"
import script from "./no-pc.vue?vue&type=script&lang=js"
export * from "./no-pc.vue?vue&type=script&lang=js"
import style0 from "./no-pc.vue?vue&type=style&index=0&id=590e66cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590e66cc",
  null
  
)

export default component.exports